import { BundleProps, ProductData } from 'utils/types';
import { Box } from '@mui/system';
import { CSSProperties } from 'react';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { StyledProduct, StyledTextContainer } from './style';
import { TooltipRenderer } from 'components/TooltipTemplate/TooltipRenderer';

const rarityStar =
  'https://media.appcharge.com/media/shop-images/cashman-assets/rarity-star.png';
const tooltipIcon =
  'https://media.appcharge.com/media/shop-images/cashman-assets/tooltip-icon-no-border.png';

const tooltipButtonStyle: CSSProperties = {
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  marginLeft: 'auto',
};

const templateTooltipStyle: CSSProperties = {
  background: 'linear-gradient(180deg, #E952B5 0%, #D735B3 100%)',
  color: '#4F018A',
  maxWidth: 220,
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  zIndex: '5',
};

const templateAdvancedTooltipStyle: CSSProperties = {
  background: 'linear-gradient(180deg, #E952B5 0%, #D735B3 100%)',
  minWidth: 160,
  borderRadius: '7px',
  zIndex: '5',
  padding: '8px',
};

interface ICashmanCasinoProductProps {
  product: ProductData;
  salePercentage?: number;
  tooltipLoadCallback?: BundleProps['tooltipLoadCallback'];
  tooltipOpenEventHandler?: BundleProps['tooltipOpenEventHandler'];
}

export const CashmanCasinoProduct: React.FC<ICashmanCasinoProductProps> = ({
  product,
  salePercentage = 0,
  tooltipLoadCallback,
  tooltipOpenEventHandler,
}) => {
  return (
    <StyledProduct className="cashman-bundle__product">
      <div className={'product-img'}>
        <img src={product.images.product} alt="product" />
      </div>
      <StyledTextContainer className="text-container">
        <Box className="quantity">
          {product && product.images.productPrefix && (
            <img src={product.images.productPrefix} alt="coin" />
          )}
          <AutoTextSize maxFontSizePx={14} minFontSizePx={6} mode="oneline">
            {product.quantityDisplay}
          </AutoTextSize>
        </Box>
        {salePercentage > 0 && (
          <AutoTextSize
            maxFontSizePx={11}
            minFontSizePx={6}
            className="stroked"
            mode="oneline"
          >
            {product.strokedSaleQuantity}
          </AutoTextSize>
        )}
        <div className="product-rarity">
          {product.rarityProductInfo?.rarityText}
          <div className="product-rarity-stars">
            {Array.from({
              length: product?.rarityProductInfo?.stars,
            }).map((_, index) => (
              <img key={index} src={rarityStar} alt="rarity star" />
            ))}{' '}
          </div>
        </div>
      </StyledTextContainer>

      <TooltipRenderer
        product={product}
        tooltipLoadCallback={tooltipLoadCallback}
        tooltipOpenEventHandler={tooltipOpenEventHandler}
        simpleTooltipStyle={templateTooltipStyle}
        advancedTooltipStyle={templateAdvancedTooltipStyle}
        buttonStyle={tooltipButtonStyle}
      >
        <img
          className={'tooltip-icon'}
          src={tooltipIcon}
          alt={'tooltip-icon'}
        />
      </TooltipRenderer>
    </StyledProduct>
  );
};
